const { dateLabel } = require('./model');
const { regionLabel } = require('./model');

async function buildActivityWorkbook(ExcelJS, report, detail) {
  const book = new ExcelJS.Workbook();
  book.creator = report.sampleData ? 'PATH — sample data' : 'PATH';
  const scope = `FY ${report.scope.fiscalLabel} · ${report.scope.period === 'full' ? 'Full year' : report.scope.period.toUpperCase()} · ${report.regionLabel}`;
  const addSheet = (name, headers, rows, widths, moneyColumn) => {
    const sheet = book.addWorksheet(name);
    sheet.addRow([report.sampleData ? 'SAMPLE DATA — Activity Report DEV preview' : 'PATH Activity Report']);
    sheet.addRow([scope]);
    sheet.addRow([`${report.scope.label} · ${report.scope.activityEnd < report.scope.start ? 'No activity yet' : `Activity through ${dateLabel(report.scope.activityEnd)}`} · As of ${dateLabel(report.scope.asOf)}${report.generatedAt ? ` · Generated ${report.generatedAt}` : ''}`]);
    sheet.addRow(['Funding includes scheduled amounts across the full selected period.']);
    sheet.addRow([]);
    sheet.addRow(headers);
    rows.forEach(row => sheet.addRow(row));
    sheet.columns.forEach((column, i) => { column.width = widths[i] || 24; });
    sheet.getRow(1).font = { bold: true, size: 14, color: { argb: 'FF23344D' } };
    sheet.getRow(6).eachCell(cell => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF23344D' } };
    });
    sheet.views = [{ state: 'frozen', ySplit: 6 }];
    sheet.autoFilter = { from: { row: 6, column: 1 }, to: { row: 6 + rows.length, column: headers.length } };
    for (let index = 7; index <= 6 + rows.length; index++) {
      const row = sheet.getRow(index);
      row.alignment = { vertical: 'top', wrapText: true };
      if (index % 2) row.eachCell(cell => { cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2F5F8' } }; });
      if (moneyColumn) row.getCell(moneyColumn).numFmt = '"C$"#,##0.00';
    }
    sheet.pageSetup = { orientation: 'landscape', fitToPage: true, fitToWidth: 1, fitToHeight: 0, printTitlesRow: '1:6' };
    return sheet;
  };
  const summary = addSheet('Summary', ['Measure', 'Total'], report.summary.map(row => [row.label, row.value]), [45, 24]);
  summary.getCell('B12').numFmt = '"C$"#,##0.00';
  summary.addRow([]);
  summary.addRow(['Clients served', `${report.applicants} distinct applicants + ${report.interactions} MSL interactions`]);
  summary.addRow(['Employment', 'Includes employed and self-employed; each person counts once.']);
  summary.addRow(['School results', 'Each person counts once; a person may also have an employment result.']);
  const detailRows = rows => rows.map(row => [row.name, regionLabel(row.province), row.date, row.description, row.recordCount || 1, row.fundingSource || '', row.amount ?? null]);
  const addDetail = (name, rows) => addSheet(name, ['Name', 'Province / Territory', 'Date', 'Service / Result', 'Contributing records', 'Funding source', 'Scheduled funding'], detailRows(rows), [26, 26, 16, 32, 22, 18, 22], 7);
  if (detail) {
    addDetail('Selected detail', detail.rows);
    book.getWorksheet('Selected detail').getCell('A5').value = `${detail.label}${detail.search ? ` · Search: ${detail.search}` : ''} · ${detail.rows.length} matching rows`;
  } else {
    addDetail('Applicants', report.details.served.filter(row => row.group === 'applicants'));
    addDetail('MSL interactions', report.details.served.filter(row => row.group === 'msl'));
    addDetail('Employed clients', report.details.employed);
    addDetail('School clients', report.details.school);
    addDetail('Applications', report.details.applications);
    addDetail('Funded clients', report.details.funded);
    addDetail('Funding lines', report.details.funding);
  }
  return book;
}

// Export values are numeric; formatting belongs to Excel rather than preformatted text.
module.exports = { buildActivityWorkbook };
